var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SB-border bottom",class:{ 'full-width': _vm.fullWidth }})
}
var staticRenderFns = []

export { render, staticRenderFns }